import React from "react";
import "./breathingBackground.css";

const BreathingBackground = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="breathing-bg">
      <div className="breathing-layer" />
      <div className="breathing-content">{children}</div>
    </div>
  );
};

export default BreathingBackground;